import InventoryList from './InventoryList';

export default InventoryList;
